/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LaundryGroupPriceListElementIntegrated
 */
export interface LaundryGroupPriceListElementIntegrated {
    /**
     * 
     * @type {number}
     * @memberof LaundryGroupPriceListElementIntegrated
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof LaundryGroupPriceListElementIntegrated
     */
    readonly name: string;
    /**
     * 
     * @type {number}
     * @memberof LaundryGroupPriceListElementIntegrated
     */
    regularAmount: number;
    /**
     * 
     * @type {number}
     * @memberof LaundryGroupPriceListElementIntegrated
     */
    happyHourAmount: number;
}

/**
 * Check if a given object implements the LaundryGroupPriceListElementIntegrated interface.
 */
export function instanceOfLaundryGroupPriceListElementIntegrated(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "regularAmount" in value;
    isInstance = isInstance && "happyHourAmount" in value;

    return isInstance;
}

export function LaundryGroupPriceListElementIntegratedFromJSON(json: any): LaundryGroupPriceListElementIntegrated {
    return LaundryGroupPriceListElementIntegratedFromJSONTyped(json, false);
}

export function LaundryGroupPriceListElementIntegratedFromJSONTyped(json: any, ignoreDiscriminator: boolean): LaundryGroupPriceListElementIntegrated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': json['index'],
        'name': json['name'],
        'regularAmount': json['regularAmount'],
        'happyHourAmount': json['happyHourAmount'],
    };
}

export function LaundryGroupPriceListElementIntegratedToJSON(value?: LaundryGroupPriceListElementIntegrated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'regularAmount': value.regularAmount,
        'happyHourAmount': value.happyHourAmount,
    };
}

